import { render } from "./ad-edit.vue?vue&type=template&id=265dc8af&scoped=true"
import script from "./ad-edit.vue?vue&type=script&lang=js"
export * from "./ad-edit.vue?vue&type=script&lang=js"

import "./ad-edit.vue?vue&type=style&index=0&id=265dc8af&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265dc8af"]])

export default __exports__